import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtDate } from "@finance/lib/api";

export function ApprovalsQueue() {
  const navigate = useNavigate();
  const [d, setD] = useState({ items: [], total: 0 });
  useEffect(() => { api.get("/approvals/mine").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d.total) return null;
  const groups = d.items.reduce((m, x) => ({ ...m, [x.kind]: (m[x.kind] || 0) + 1 }), {});
  return (
    <div className="mt-4 rounded-xl border border-[#1B4383]/30 border-l-4 border-l-[#1B4383] bg-white p-4" data-testid="approvals-queue">
      <div className="font-display text-lg font-bold text-gray-900">Awaiting my approval · <span data-testid="approvals-total">{d.total}</span></div>
      <div className="text-xs text-gray-500">{Object.entries(groups).map(([k, v]) => `${v} ${k}`).join(" · ")}</div>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {d.items.slice(0, 12).map((x) => (
          <button key={`${x.kind}-${x.id}`} data-testid={`approval-chip-${x.id}`} onClick={() => navigate(x.link)}
            className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 px-2.5 py-1 text-xs hover:bg-[#1B4383]/5">
            <span className="rounded-sm bg-[#1B4383]/10 px-1 text-[10px] font-bold text-[#1B4383]">{x.kind}</span>
            <b>{x.no || "—"}</b>{x.by && <span className="text-gray-400">{x.by} · {fmtDate(x.at)}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
